import { packages } from '@shared/api/services'
import { queryClient } from '@shared/api/query-client'
import { useMutation } from '@tanstack/react-query'

export const useCreateProfilePackage = (onSuccess = () => {}) => {
	return useMutation({
		mutationFn: packages.createProfilePackage,
		onSuccess: (response) => {
			queryClient.invalidateQueries(['profile-packages'])
			onSuccess(response?.data?.data ?? response?.data ?? response)
		},
	})
}
